import gql from 'graphql-tag';

export default gql`
  mutation ($name: String!, $description: String, $photo: String, $index: Float, $status: EnumCourseStatus) {
    createCourse(
      record: { name: $name, description: $description, photo: $photo, index: $index, status: $status }
    ) {
      recordId
    }
  }
`;
